// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@turnerBlueprint/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import IconPrint from "@turnerBlueprint/XDL/Icons/IconPrint";
import { iconButtonCommonStyles } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

headerStyles.container = {
    css: css`
        margin-bottom: 20px;
    `,
};

headerStyles.titleText = {
   variant: "h1"
};

headerStyles.orderNumberText = {
   variant: "h2"
};

headerStyles.emailSentText = {
    size: 14,
    lineHeight: "22px",
};

headerStyles.printButton = {
    ...iconButtonCommonStyles(
        IconPrint,
        undefined,
        {
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
        },
        undefined,
        {
            css: css`
                margin-top: 16px;
            `,
        },
    ),
};
